/**
 * Hlavička — kontakt a účet v .navigation-buttons (Shoptet Disco)
 *
 * Disco nemá v hlavičce ani telefon, ani odkaz na účet — přepínač přihlášení
 * je jen v horní liště (.top-navigation-bar .top-navigation-tools). Oboje
 * doplníme do .navigation-buttons, stejně jako na vzorovém www.abstore.cz.
 *
 * Přihlášení: klon přepínače Shoptetu. Ten obsluhuje .toggle-window
 * delegovaně na document (přepíná body.login-window-visible), takže klon
 * funguje bez další logiky. Je-li zákazník přihlášený, Shoptet místo
 * přepínače vykreslí odkaz .top-nav-button-account — pak vložíme odkaz
 * na účet.
 *
 * Vzhled řeší CSS v layouts/header.scss (.header-contact, .header-login).
 */
(function () {
	var PHONE = '+420 777 493 939';
	var PHONE_HREF = 'tel:+420777493939';
	var HOURS = 'Po–Pá 9:30 – 18:00';

	function addContact(buttons) {
		if (document.querySelector('.header-contact')) return;

		var wrap = document.createElement('div');
		wrap.className = 'header-contact';

		var link = document.createElement('a');
		link.className = 'header-contact__item';
		link.href = PHONE_HREF;

		var text = document.createElement('div');

		var label = document.createElement('span');
		label.className = 'header-contact__label';
		label.textContent = HOURS;

		var value = document.createElement('span');
		value.className = 'header-contact__value';
		value.textContent = PHONE;

		text.appendChild(label);
		text.appendChild(value);
		link.appendChild(text);
		wrap.appendChild(link);

		buttons.parentNode.insertBefore(wrap, buttons);
	}

	function addLogin(buttons) {
		if (buttons.querySelector('.header-login')) return;

		var account = document.querySelector('.top-nav-button-account');
		var source = document.querySelector('.top-nav-button-login');
		var el;

		if (account) {
			el = document.createElement('a');
			el.href = account.getAttribute('href') || '/klient/';
			el.setAttribute('aria-label', account.textContent.trim() || 'Můj účet');
		} else if (source) {
			el = source.cloneNode(false);
			el.classList.remove('top-nav-button', 'top-nav-button-login');
			el.removeAttribute('data-testid');
		} else {
			el = document.createElement('a');
			el.href = '/login/';
			el.setAttribute('aria-label', 'Přihlášení');
		}

		el.classList.add('header-login');
		el.textContent = '';

		var cart = buttons.querySelector('.cart-count');
		buttons.insertBefore(el, cart);
	}

	function init() {
		var buttons = document.querySelector('#header .navigation-buttons');
		if (!buttons) return;

		addContact(buttons);
		addLogin(buttons);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
